var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAddressEdit = function SvgAddressEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "address-edit_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-2-1h18v18H-2z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#address-edit_svg__a)",
    "data-name": "Scroll Group 35",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    },
    transform: "translate(2 1)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#0eb948",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    "data-name": "Group 2621"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.117 15H14",
    "data-name": "Path 18607"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.558 1.638a1.691 1.691 0 0 1 2.408-.243l1.34 1.081a1.757 1.757 0 0 1 .556 2.395c-.026.044-7.371 9.585-7.371 9.585a1.3 1.3 0 0 1-1.012.508L.667 15l-.634-2.786a1.346 1.346 0 0 1 .244-1.12Z",
    "data-name": "Path 18608"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.122 3.4 4.423 3.4",
    "data-name": "Path 18609"
  })))));
};
export default SvgAddressEdit;